






















































































import { defineComponent, reactive, SetupContext, computed } from '@vue/composition-api';
import EntityDialog from '@/components/common/EntityDialog.vue';
import { Category, CategoryPreview } from '@/models/entities/Category';
import ImageUpload from '@/components/utils/ImageUpload.vue';
import { DropdownFilter, IDropdownFilter } from '@/models/filters/Filters';
import PaginatedAutocomplete from '@/components/utils/PaginatedAutocomplete.vue';
import { Product } from '@/models/entities/Product';
import { Location } from '@/models/entities/Location';
import LocationsSimpleTable from '@/components/entities/products/productFields/LocationsSimpleTable.vue';
import { ImageFile } from '@/models/entities/ImageFile';
import { ShopifyProduct } from '@/models/entities/ShopifyProduct';
import LogoPlacementComponent from '@/components/entities/products/productFields/LogoPlacementComponent.vue';
import { FontGroup } from '@/models/entities/FontGroup';

interface Props {
  id: string;
}

interface State {
  entity: Product;
  loading: boolean;
}

const Component = defineComponent({
  name: 'NewProductDialog',

  components: {
    EntityDialog,
    ImageUpload,
    PaginatedAutocomplete,
    LocationsSimpleTable,
    LogoPlacementComponent,
  },

  props: {
    id: String,
  },

  setup(props: Props, { root: { $store } }: SetupContext) {
    let product = new Product({});

    const state = reactive({
      entity: product,
      loading: computed(() => $store.getters['productsModule/loading']),
    }) as State;

    const rules = {
      name: [(v: string) => !!v || 'Name is required'],
      image: [(v: ImageFile) => (v && v.url !== '') || 'Image is required'],
      categories: [
        (v: CategoryPreview[]) => (v && v.length > 0) || 'Category is required',
      ],
      shopifyProduct: [
        (v: ShopifyProduct) =>
          (v && v.id >= 1) || 'Product should be connected to real Shopify Product',
      ],
    };

    function setNewCategory(newCategory: (CategoryPreview | number)[]) {
      const newCategories: CategoryPreview[] = [];
      newCategory.forEach(cat => {
        if (typeof cat === 'number') {
          const old = state.entity.categories.find(item => item.id === cat);
          if (old) newCategories.push(old);
        } else {
          newCategories.push(cat);
        }
      });
      state.entity.categories = newCategories;
    }
    function setNewFontGroup(newFontGroup: FontGroup) {
      state.entity.fontGroup = newFontGroup;
    }

    const categoryFilterDropdown: IDropdownFilter = new DropdownFilter({
      label: 'Category',
      itemsModuleName: 'categoriesModule',
      initialValue: [],
    });
    const shopifyFilterDropdown = new DropdownFilter({
      label: 'Original Shopify Product',
      itemsModuleName: 'shopifyProductsModule',
      initialValue: product.shopifyProduct.id,
      textPropName: 'title',
    });
    const fontGroupFilterDropdown = new DropdownFilter({
      label: 'Font Group',
      itemsModuleName: 'fontGroupsModule',
      initialValue: product.fontGroup?.id,
    });

    function addLocation(newLocation: Location) {
      if (newLocation.imageFile && newLocation.name)
        state.entity.locations.push(newLocation);
    }

    return {
      state,
      rules,
      setNewCategory,
      setNewFontGroup,
      categoryFilterDropdown,
      shopifyFilterDropdown,
      fontGroupFilterDropdown,
      addLocation,
    };
  },
});
export default Component;
